import { collectionEngineV1 } from '../apis.js';
const workflowsAPI = collectionEngineV1('/workflows');
export const get = (casualConsistency) => workflowsAPI('GET', `/${casualConsistency ? '?casualConsistency=true' : ''}`);
export const del = (workflowId) => workflowsAPI('DELETE', `/${workflowId}`);
export const getById = (id) => workflowsAPI('GET', `/${id}`);
export const create = (newWorkflow) => workflowsAPI('POST', '/', { body: newWorkflow });
export const update = (workflowId, updateWorkflow) => workflowsAPI('PATCH', `/${workflowId}`, { body: updateWorkflow });
export const duplicateWorkflow = (workflowId) => workflowsAPI('POST', `/duplicate/${workflowId}`);
export const runTask = (workflowId, caseId, taskId) => workflowsAPI('POST', `/${workflowId}/${caseId}/run/${taskId}`);
export const rollback = (caseId, updateId) => workflowsAPI('POST', `/${caseId}/rollback/${updateId}`);
export const getStats = async (workflowId, caseFilter) => {
    if (workflowId === null) {
        return null;
    }
    return workflowsAPI('POST', `/stats/${workflowId}`, {
        body: { caseFilter },
    });
};
export const getTaskStats = (workflowId, taskId, caseFilter) => workflowsAPI('POST', `/stats/${workflowId}/${taskId}`, {
    body: { caseFilter },
});
//# sourceMappingURL=workflows.js.map